/**
 *
 * Anchor
 *
 */

import React, { ComponentType, ReactNode } from 'react';
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';
import StreamlineIcon from '@fil-react-components/streamline-icon';

import styles from './Anchor.style';

export interface AnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /**
   * aria-label for anchor tag
   */
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
  href?: string;
  id?: string;
  /**
   * default false
   */
  secondary?: boolean;
  /**
   * default right
   */
  iconPosition?: 'left' | 'right';
  // @ts-ignore
  icon?: ComponentType;
  /**
   * default true
   */
  underline?: boolean;
  /**
   * default true
   */
  underlineOnHover?: boolean;
}

const Anchor: React.FC<AnchorProps> = ({
  ariaLabel,
  children,
  className,
  href = '#',
  id,
  target = '_self',
  iconPosition = 'right',
  icon,
  secondary,
  underlineOnHover,
  underline,
  ...extraProps
}) => (
  <a
    aria-label={ariaLabel}
    className={classnames(className, 'fil-anchor ', { 'inline-flex align-middle': icon })}
    href={href}
    id={id}
    target={target}
    {...extraProps}
  >
    {icon && iconPosition === 'left' && <StreamlineIcon icon={icon} size={16} />}
    {children}
    {icon && iconPosition === 'right' && <StreamlineIcon icon={icon} size={16} />}
  </a>
);

Anchor.displayName = 'Anchor';

export default withStyles(Anchor, styles, {
  attrs: (props: any) => ({ fontSize: props.fontSize || 'regular' }),
});
